const SETUSERINFO = 'SET_USER_INFO'
const SETORG = 'SET_ORG'
const SETCURRENTORG = 'SET_CURRENT_ORG'
const SETGHOSTUSER = 'SET_GHOST_USER'

export { SETUSERINFO, SETGHOSTUSER, SETORG, SETCURRENTORG }
